import { Content, Header, Page } from '@backstage/core-components';
import { useState } from 'react';
import { OrganizationDiagramButton } from './OrganizationInheritanceDiagram';
import { OrganizationGroupsPanel } from './OrganizationGroupsPanel';
import { OrganizationInheritanceDiagramDialog } from './OrganizationInheritanceDiagramDialog';

export function OrganizationPage() {
  const [diagramOpen, setDiagramOpen] = useState(false);

  return (
    <Page themeId="tool">
      <Header
        title="Organization"
        subtitle="Teams and groups from the invisible org catalog"
      >
        <OrganizationDiagramButton onClick={() => setDiagramOpen(true)} />
      </Header>
      <Content>
        <OrganizationGroupsPanel />
      </Content>
      <OrganizationInheritanceDiagramDialog
        open={diagramOpen}
        onClose={() => setDiagramOpen(false)}
      />
    </Page>
  );
}
